import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate, useParams } from "react-router";

export default function GeneralRoute({ children }) {
  const { siteLang } = useParams();
  const { pathname } = useLocation();
  const navigate = useNavigate();

  const { i18n } = useTranslation();
  const { lang } = useSelector((state) => state.lang);

  const langs = ["uz", "ru", "en"];

  useEffect(() => {
    localStorage.removeItem("lang");
    localStorage.setItem("lang", lang);
    i18n.changeLanguage(siteLang);
    if (siteLang && langs.includes(siteLang)) {
      return;
    } else {
      navigate(`/${localStorage.getItem("lang")}${pathname}`);
    }
  }, [siteLang]);

  return children;
}
